import Constants from 'src/utilities/constants'
import axios from 'axios'
import _ from 'lodash'
import {OK} from 'http-status-codes'
import {addHeaders} from 'src/utilities/authHeader'
import {cleanCamundaDeploymentName} from 'src/utilities/utils'

export default {
  namespaced: true,
  actions: {
    async deploy({dispatch}, camundaPayload) {
      let url = process.env.VUE_APP_PTRAC_API_URI + '/camunda/deployment/create'
      const errors = []

      let i = 0
      for (i = 0; i < camundaPayload.files.length; i++) {
        const file = camundaPayload.files[i]

        if (!file.name.endsWith('.bpmn')) {
          errors.push({
            message: file.name + ' is invalid. File must have .bpmn file extension'
          })
        }
      }

      if (errors.length > 0) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          errors
        }
      }

      for (i = 0; i < camundaPayload.files.length; i++) {
        try {
          const file = camundaPayload.files[i]
          const deploymentName = cleanCamundaDeploymentName(file.name)
          const formData = new FormData()
          formData.append('deployment-name', deploymentName)
          formData.append(file.name, file)
          const config = { headers: await addHeaders(Constants.HEADERS.CAMUNDA_UPLOAD.headers) }
          const response = await axios.post(url, formData, config)

          if (OK !== response.status) {
            errors.push('Failed to create deployment for: ', file.name)
            continue
          }

          // update PTRAC record start
          const ptracPayload = {
            id: response.data.id,
            endpoint: 'camunda-deployments',
            data: {
              name: deploymentName,
              departmentId: camundaPayload.departmentId,
              createdAt: new Date(),
              active: true
            }
          }

          const pds = response.data.deployedProcessDefinitions
          ptracPayload.data.processDefinitions = []

          for (let prop in pds) {
            const pd = pds[prop]
            ptracPayload.data.processDefinitions.push({
              id: pd.id,
              key: pd.key,
              name: pd.name,
              resource: pd.resource,
              version: pd.version
            })
          }

          await dispatch('put', ptracPayload, {root: true})
          // update PTRAC record end
        } catch (error) {
          return {
            result: Constants.RETURN_CODES.ERROR,
            message: _.get(error, 'response.data.message'),
            errors: [error]
          }
        }
      } // end for

      this.$eventHub.$emit('refreshCamundaDeployments')

      return {
        result: Constants.RETURN_CODES.SUCCESS
      }
    }
  }
}
